import { lazyLoad } from "utils/loadable";

export const AdminJobAppliedCandidates = lazyLoad(
  () => import("./index"),
  (module) => module.AdminJobAppliedCandidates
);
